export const getNavbarBrowsePaths = (intl) => {
  const browsePaths = {
    'en-us': {
      locations: {
        display: intl.formatMessage({
          defaultMessage: 'Locations',
          id: 'navbar_browse_paths.locations'
        }),
        id: 'en-us_locations',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Los Angeles',
              id: 'navbar_browse_paths.locations.los_angeles'
            }),
            url: '/venues/los-angeles--ca',
            id: 'en-us_los_angeles'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'New York',
              id: 'navbar_browse_paths.locations.new_york'
            }),
            url: '/venues/new-york--ny',
            id: 'en-us_new_york'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Chicago',
              id: 'navbar_browse_paths.locations.chicago'
            }),
            url: '/venues/chicago--il',
            id: 'en-us_chicago'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Atlanta',
              id: 'navbar_browse_paths.locations.atlanta'
            }),
            url: '/venues/atlanta--ga',
            id: 'en-us_atlanta'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'San Francisco',
              id: 'navbar_browse_paths.locations.san_francisco'
            }),
            url: '/venues/san-francisco--ca',
            id: 'en-us_san_fransisco'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Seattle',
              id: 'navbar_browse_paths.locations.seattle'
            }),
            url: '/venues/seattle--wa',
            id: 'en-us_seattle'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Houston',
              id: 'navbar_browse_paths.locations.houston'
            }),
            url: '/venues/houston--tx',
            id: 'en-us_houston'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Dallas',
              id: 'navbar_browse_paths.locations.dallas'
            }),
            url: '/venues/dallas--tx',
            id: 'en-us_dallas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Austin',
              id: 'navbar_browse_paths.locations.austin'
            }),
            url: '/venues/austin--tx',
            id: 'en-us_austin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Philadelphia',
              id: 'navbar_browse_paths.locations.philadelphia'
            }),
            url: '/venues/philadelphia--pa',
            id: 'en-us_philadelphia'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'San Diego',
              id: 'navbar_browse_paths.locations.san_diego'
            }),
            url: '/venues/san-diego--ca',
            id: 'en-us_san_diego'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Washington D.C.',
              id: 'navbar_browse_paths.locations.washington_dc'
            }),
            url: '/venues/washington--dc',
            id: 'en-us_washington_dc'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.locations.see_all'
            }),
            url: '/venues/locations',
            id: 'en-us_see_all_locations'
          }
        ]
      },
      activities: {
        display: intl.formatMessage({
          defaultMessage: 'Activities',
          id: 'navbar_browse_paths.activities'
        }),
        id: 'en-us_activities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photo Shoot',
              id: 'navbar_browse_paths.activities.photo_shoot'
            }),
            url: '/plan/photo-shoot',
            id: 'en-us_photo_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Video Shoot',
              id: 'navbar_browse_paths.activities.video_shoot'
            }),
            url: '/plan/video-shoot',
            id: 'en-us_video_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Meeting',
              id: 'navbar_browse_paths.activities.meeting'
            }),
            url: '/plan/meeting',
            id: 'en-us_meeting'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party',
              id: 'navbar_browse_paths.activities.party'
            }),
            url: '/plan/party',
            id: 'en-us_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Workshop',
              id: 'navbar_browse_paths.activities.workshop'
            }),
            url: '/plan/workshop',
            id: 'en-us_workshop'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby Shower',
              id: 'navbar_browse_paths.activities.baby_shower'
            }),
            url: '/plan/baby-shower',
            id: 'en-us_baby_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Retreat',
              id: 'navbar_browse_paths.activities.retreat'
            }),
            url: '/plan/retreat',
            id: 'en-us_retreat'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Dinner',
              id: 'navbar_browse_paths.activities.dinner'
            }),
            url: '/plan/dinner',
            id: 'en-us_dinner'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Training',
              id: 'navbar_browse_paths.activities.training'
            }),
            url: '/plan/training',
            id: 'en-us_training'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Wedding',
              id: 'navbar_browse_paths.activities.wedding'
            }),
            url: '/plan/wedding',
            id: 'en-us_wedding'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday Party',
              id: 'navbar_browse_paths.activities.birthday_party'
            }),
            url: '/plan/birthday-party',
            id: 'en-us_birthday_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal Shower',
              id: 'navbar_browse_paths.activities.bridal_shower'
            }),
            url: '/plan/bridal-shower',
            id: 'en-us_bridal_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.activities.see_all'
            }),
            url: '/plan/activities',
            id: 'en-us_see_all_activities'
          }
        ]
      },
      spaceTypes: {
        display: intl.formatMessage({
          defaultMessage: 'Space Types',
          id: 'navbar_browse_paths.space_types'
        }),
        id: 'en-us_space_types',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'House',
              id: 'navbar_browse_paths.space_types.house'
            }),
            url: '/plan/house',
            id: 'en-us_house'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bar',
              id: 'navbar_browse_paths.space_types.bar'
            }),
            url: '/plan/bar',
            id: 'en-us_bar'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Garage',
              id: 'navbar_browse_paths.space_types.garage'
            }),
            url: '/plan/garage',
            id: 'en-us_garage'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Warehouse',
              id: 'navbar_browse_paths.space_types.warehouse'
            }),
            url: '/plan/warehouse',
            id: 'en-us_warehouse'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cabin',
              id: 'navbar_browse_paths.space_types.cabin'
            }),
            url: '/plan/cabin',
            id: 'en-us_cabin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Movie Theater',
              id: 'navbar_browse_paths.space_types.movie_theater'
            }),
            url: '/plan/movie-theater',
            id: 'en-us_movie_theater'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Mansion',
              id: 'navbar_browse_paths.space_types.mansion'
            }),
            url: '/plan/mansion',
            id: 'en-us_mansion'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Community Center',
              id: 'navbar_browse_paths.space_types.community_center'
            }),
            url: '/plan/community-center',
            id: 'en-us_community_center'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Castle',
              id: 'navbar_browse_paths.space_types.castle'
            }),
            url: '/plan/castle',
            id: 'en-us_castle'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Basketball Court',
              id: 'navbar_browse_paths.space_types.basketball-court'
            }),
            url: '/plan/basketball-court',
            id: 'en-us_basketball_court'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Commercial Kitchen',
              id: 'navbar_browse_paths.space_types.commercial_kitchen'
            }),
            url: '/plan/commercial-kitchen',
            id: 'en-us_commercial_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Barn',
              id: 'navbar_browse_paths.space_types.barn'
            }),
            url: '/plan/barn',
            id: 'en-us_barn'
          },
        ]
      },
      amenities: {
        display: intl.formatMessage({
          defaultMessage: 'Amenities',
          id: 'navbar_browse_paths.amenities'
        }),
        id: 'en-us_amenities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Kitchen',
              id: 'navbar_browse_paths.amenities.kitchen'
            }),
            url: '/plan/kitchen',
            id: 'en-us_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Lounge',
              id: 'navbar_browse_paths.amenities.lounge'
            }),
            url: '/plan/lounge',
            id: 'en-us_lounge'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cyclorama',
              id: 'navbar_browse_paths.amenities.cyclorama'
            }),
            url: '/plan/cyclorama',
            id: 'en-us_cyclorama'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Piano',
              id: 'navbar_browse_paths.amenities.piano'
            }),
            url: '/plan/piano',
            id: 'en-us_piano'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pool',
              id: 'navbar_browse_paths.amenities.pool'
            }),
            url: '/plan/pool',
            id: 'en-us_pool'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bathtub',
              id: 'navbar_browse_paths.amenities.bathtub'
            }),
            url: '/plan/bathtub',
            id: 'en-us_bathtub'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Patio',
              id: 'navbar_browse_paths.amenities.patio'
            }),
            url: '/plan/patio',
            id: 'en-us_patio'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Green Screen',
              id: 'navbar_browse_paths.amenities.green_screen'
            }),
            url: '/plan/green-screen',
            id: 'en-us_green_screen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Deck',
              id: 'navbar_browse_paths.amenities.deck'
            }),
            url: '/plan/deck',
            id: 'en-us_deck'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fireplace',
              id: 'navbar_browse_paths.amenities.fireplace'
            }),
            url: '/plan/fireplace',
            id: 'en-us_fireplace'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Grill',
              id: 'navbar_browse_paths.amenities.grill'
            }),
            url: '/plan/grill',
            id: 'en-us_grill'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fire Pit',
              id: 'navbar_browse_paths.amenities.fire_pit'
            }),
            url: '/plan/fire-pit',
            id: 'en-us_fire_pit'
          },
        ]
      },
      ideas: {
        display: intl.formatMessage({
          defaultMessage: 'Ideas',
          id: 'navbar_browse_paths.ideas'
        }),
        id: 'en-us_ideas',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photoshoot ideas',
              id: 'navbar_browse_paths.ideas.photoshoot_ideas'
            }),
            url: '/ideas/photo-shoot/all',
            id: 'en-us_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby shower ideas',
              id: 'navbar_browse_paths.ideas.baby_shower_ideas'
            }),
            url: '/ideas/baby-shower/all',
            id: 'en-us_baby_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party ideas',
              id: 'navbar_browse_paths.ideas.party_ideas'
            }),
            url: '/ideas/party/all',
            id: 'en-us_party_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal shower ideas',
              id: 'navbar_browse_paths.ideas.bridal_shower_ideas'
            }),
            url: '/ideas/bridal-shower/all',
            id: 'en-us_bridal_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday photoshoot ideas',
              id: 'navbar_browse_paths.ideas.birthday_photoshoot_ideas'
            }),
            url: '/ideas/birthday-photo-shoot/all',
            id: 'en-us_birthday_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Boudoir photoshoot ideas',
              id: 'navbar_browse_paths.ideas.boudoir_photoshoot_ideas'
            }),
            url: '/ideas/boudoir-photo-shoot/all',
            id: 'en-us_boudoir_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Couples photoshoot ideas',
              id: 'navbar_browse_paths.ideas.couples_photoshoot_ideas'
            }),
            url: '/ideas/couples-photo-shoot/all',
            id: 'en-us_couples_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Spring photoshoot ideas',
              id: 'navbar_browse_paths.ideas.spring_photoshoot_ideas'
            }),
            url: '/ideas/spring-photo-shoot/all',
            id: 'en-us_spring_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Outdoor photoshoot ideas',
              id: 'navbar_browse_paths.ideas.outdoor_photoshoot_ideas'
            }),
            url: '/ideas/outdoor-photo-shoot/all',
            id: 'en-us_outdoor_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Summer photoshoot ideas',
              id: 'navbar_browse_paths.ideas.summer_photoshoot_ideas'
            }),
            url: '/ideas/summer-photo-shoot/all',
            id: 'en-us_summer_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Black and white photoshoot ideas',
              id: 'navbar_browse_paths.ideas.black_and_white_photoshoot_ideas'
            }),
            url: '/ideas/black-and-white-photo-shoot/all',
            id: 'en-us_black_and_white_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pink photoshoot ideas',
              id: 'navbar_browse_paths.ideas.pink_photoshoot_ideas'
            }),
            url: '/ideas/pink-photo-shoot/all',
            id: 'en-us_pink_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.ideas.see_all'
            }),
            url: '/ideas/all',
            id: 'en-us_see_all_ideas'
          }
        ]
      }
    },
    /**
     ***************************************************
     * FRANCE
     *******************************
     */
    'fr-fr': {
      locations: {
        display: intl.formatMessage({
          defaultMessage: 'Locations',
          id: 'navbar_browse_paths.locations'
        }),
        id: 'fr-fr_locations',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Paris',
              id: 'navbar_browse_paths.locations.paris'
            }),
            url: '/fr/venues/fr/paris--île-de-france',
            id: 'fr-fr_paris'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Boulogne-Billancourt',
              id: 'navbar_browse_paths.locations.boulogne_billancourt'
            }),
            url: '/fr/venues/fr/boulogne-billancourt--île-de-france',
            id: 'fr-fr_boulogne_billancourt'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Montreuil',
              id: 'navbar_browse_paths.locations.montreuil'
            }),
            url: '/fr/venues/fr/montreuil--île-de-france',
            id: 'fr-fr_montreuil'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Ivry-sur-Seine',
              id: 'navbar_browse_paths.locations.ivry_sur_seine'
            }),
            url: '/fr/venues/fr/ivry-sur-seine--île-de-france',
            id: 'fr-fr_ivry_sur_seine'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Arcueil',
              id: 'navbar_browse_paths.locations.arcueil'
            }),
            url: '/fr/venues/fr/arcueil--île-de-france',
            id: 'fr-fr_arcueil'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Asnières sur Seine',
              id: 'navbar_browse_paths.locations.asnières_sur_seine'
            }),
            url: '/fr/venues/fr/asnières-sur-seine--île-de-france',
            id: 'fr-fr_asnières_sur_seine'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Saint-Maur-des-Fossés',
              id: 'navbar_browse_paths.locations.saint_maur_des_fossés'
            }),
            url: '/fr/venues/fr/saint-maur-des-fossés--île-de-france',
            id: 'fr-fr_saint_maur_des_fossés'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pantin',
              id: 'navbar_browse_paths.locations.pantin'
            }),
            url: '/fr/venues/fr/pantin--île-de-france',
            id: 'fr-fr_pantin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Neuilly-Sur-Seine',
              id: 'navbar_browse_paths.locations.neuilly_sur_seine'
            }),
            url: '/fr/venues/fr/neuilly-sur-seine--île-de-france',
            id: 'fr-fr_neuilly_sur_seine'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bagnolet',
              id: 'navbar_browse_paths.locations.bagnolet'
            }),
            url: '/fr/venues/fr/bagnolet--île-de-france',
            id: 'fr-fr_bagnolet'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Malakoff',
              id: 'navbar_browse_paths.locations.malakoff'
            }),
            url: '/fr/venues/fr/malakoff--île-de-france',
            id: 'fr-fr_malakoff'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Colombes',
              id: 'navbar_browse_paths.locations.colombes'
            }),
            url: '/fr/venues/fr/colombes--île-de-france',
            id: 'fr-fr_colombes'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Saint Ouen',
              id: 'navbar_browse_paths.locations.saint_ouen'
            }),
            url: '/fr/venues/fr/saint-ouen--île-de-france',
            id: 'fr-fr_saint_ouen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Issy Les Moulineaux',
              id: 'navbar_browse_paths.locations.issy_les_moulineaux'
            }),
            url: '/fr/venues/fr/issy-les-moulineaux--île-de-france',
            id: 'fr-fr_issy_les_moulineaux'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Vitry-sur-Seine',
              id: 'navbar_browse_paths.locations.vitry_sur_seine'
            }),
            url: '/fr/venues/fr/vitry-sur-seine--île-de-france',
            id: 'fr-fr_vitry_sur_seine'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.locations.see_all'
            }),
            url: '/fr/venues/locations',
            id: 'fr-fr-see_all_locations'
          }
        ]
      },
      activities: {
        display: intl.formatMessage({
          defaultMessage: 'Activities',
          id: 'navbar_browse_paths.activities'
        }),
        id: 'fr-fr_activities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photo Shoot',
              id: 'navbar_browse_paths.activities.photo_shoot'
            }),
            url: '/fr/plan/photo-shoot',
            id: 'fr-fr_photo_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Video Shoot',
              id: 'navbar_browse_paths.activities.video_shoot'
            }),
            url: '/fr/plan/video-shoot',
            id: 'fr-fr_video_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Meeting',
              id: 'navbar_browse_paths.activities.meeting'
            }),
            url: '/fr/plan/meeting',
            id: 'fr-fr_meeting'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party',
              id: 'navbar_browse_paths.activities.party'
            }),
            url: '/fr/plan/party',
            id: 'fr-fr_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Workshop',
              id: 'navbar_browse_paths.activities.workshop'
            }),
            url: '/fr/plan/workshop',
            id: 'fr-fr_workshop'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby Shower',
              id: 'navbar_browse_paths.activities.baby_shower'
            }),
            url: '/fr/plan/baby-shower',
            id: 'fr-fr-_baby-shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Retreat',
              id: 'navbar_browse_paths.activities.retreat'
            }),
            url: '/fr/plan/retreat',
            id: 'fr-fr_retreat'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Dinner',
              id: 'navbar_browse_paths.activities.dinner'
            }),
            url: '/fr/plan/dinner',
            id: 'fr-fr_dinner'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Training',
              id: 'navbar_browse_paths.activities.training'
            }),
            url: '/fr/plan/training',
            id: 'fr-fr_training'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Wedding',
              id: 'navbar_browse_paths.activities.wedding'
            }),
            url: '/fr/plan/wedding',
            id: 'fr-fr_wedding'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday Party',
              id: 'navbar_browse_paths.activities.birthday_party'
            }),
            url: '/fr/plan/birthday-party',
            id: 'fr-fr_birthday_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal Shower',
              id: 'navbar_browse_paths.activities.bridal_shower'
            }),
            url: '/fr/plan/bridal-shower',
            id: 'fr-fr_bridal_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.activities.see_all'
            }),
            url: '/fr/plan/activities',
            id: 'fr-fr-_see_all_activities'
          }
        ]
      },
      spaceTypes: {
        display: intl.formatMessage({
          defaultMessage: 'Space Types',
          id: 'navbar_browse_paths.space_types'
        }),
        id: 'fr-fr_space_types',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'House',
              id: 'navbar_browse_paths.space_types.house'
            }),
            url: '/fr/plan/house',
            id: 'fr-fr_house'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bar',
              id: 'navbar_browse_paths.space_types.bar'
            }),
            url: '/fr/plan/bar',
            id: 'fr-fr_bar'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Garage',
              id: 'navbar_browse_paths.space_types.garage'
            }),
            url: '/fr/plan/garage',
            id: 'fr-fr_garage'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Warehouse',
              id: 'navbar_browse_paths.space_types.warehouse'
            }),
            url: '/fr/plan/warehouse',
            id: 'fr-fr_warehouse'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cabin',
              id: 'navbar_browse_paths.space_types.cabin'
            }),
            url: '/fr/plan/cabin',
            id: 'fr-fr_cabin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Movie Theater',
              id: 'navbar_browse_paths.space_types.movie_theater'
            }),
            url: '/fr/plan/movie-theater',
            id: 'fr-fr_movie_theater'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Mansion',
              id: 'navbar_browse_paths.space_types.mansion'
            }),
            url: '/fr/plan/mansion',
            id: 'fr-fr_mansion'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Community Center',
              id: 'navbar_browse_paths.space_types.community_center'
            }),
            url: '/fr/plan/community-center',
            id: 'fr-fr_community_center'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Castle',
              id: 'navbar_browse_paths.space_types.castle'
            }),
            url: '/fr/plan/castle',
            id: 'fr-fr_castle'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Basketball Court',
              id: 'navbar_browse_paths.space_types.basketball-court'
            }),
            url: '/fr/plan/basketball-court',
            id: 'fr-fr_basketball_court'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Commercial Kitchen',
              id: 'navbar_browse_paths.space_types.commercial_kitchen'
            }),
            url: '/fr/plan/commercial-kitchen',
            id: 'fr-fr_commercial_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Barn',
              id: 'navbar_browse_paths.space_types.barn'
            }),
            url: '/fr/plan/barn',
            id: 'fr-fr_barn'
          },
        ]
      },
      amenities: {
        display: intl.formatMessage({
          defaultMessage: 'Amenities',
          id: 'navbar_browse_paths.amenities'
        }),
        id: 'fr-fr_amenities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Kitchen',
              id: 'navbar_browse_paths.amenities.kitchen'
            }),
            url: '/fr/plan/kitchen',
            id: 'fr-fr_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Lounge',
              id: 'navbar_browse_paths.amenities.lounge'
            }),
            url: '/fr/plan/lounge',
            id: 'fr-fr_lounge'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cyclorama',
              id: 'navbar_browse_paths.amenities.cyclorama'
            }),
            url: '/fr/plan/cyclorama',
            id: 'fr-fr_cyclorama'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Piano',
              id: 'navbar_browse_paths.amenities.piano'
            }),
            url: '/fr/plan/piano',
            id: 'fr-fr_piano'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pool',
              id: 'navbar_browse_paths.amenities.pool'
            }),
            url: '/fr/plan/pool',
            id: 'fr-fr_pool'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bathtub',
              id: 'navbar_browse_paths.amenities.bathtub'
            }),
            url: '/fr/plan/bathtub',
            id: 'fr-fr_bathtub'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Patio',
              id: 'navbar_browse_paths.amenities.patio'
            }),
            url: '/fr/plan/patio',
            id: 'fr-fr_patio'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Green Screen',
              id: 'navbar_browse_paths.amenities.green_screen'
            }),
            url: '/fr/plan/green-screen',
            id: 'fr-fr_green_screen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Deck',
              id: 'navbar_browse_paths.amenities.deck'
            }),
            url: '/fr/plan/deck',
            id: 'fr-fr_deck'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fireplace',
              id: 'navbar_browse_paths.amenities.fireplace'
            }),
            url: '/fr/plan/fireplace',
            id: 'fr-fr_fireplace'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Grill',
              id: 'navbar_browse_paths.amenities.grill'
            }),
            url: '/fr/plan/grill',
            id: 'fr-fr_grill'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fire Pit',
              id: 'navbar_browse_paths.amenities.fire_pit'
            }),
            url: '/fr/plan/fire-pit',
            id: 'fr-fr_fire_pit'
          },
        ]
      },
      ideas: {
        display: intl.formatMessage({
          defaultMessage: 'Ideas',
          id: 'navbar_browse_paths.ideas'
        }),
        id: 'fr-fr_ideas',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photoshoot ideas',
              id: 'navbar_browse_paths.ideas.photoshoot_ideas'
            }),
            url: '/fr/ideas/photo-shoot/all',
            id: 'fr-fr_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby shower ideas',
              id: 'navbar_browse_paths.ideas.baby_shower_ideas'
            }),
            url: '/fr/ideas/baby-shower/all',
            id: 'fr-fr_baby_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party ideas',
              id: 'navbar_browse_paths.ideas.party_ideas'
            }),
            url: '/fr/ideas/party/all',
            id: 'fr-fr_party_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal shower ideas',
              id: 'navbar_browse_paths.ideas.bridal_shower_ideas'
            }),
            url: '/fr/ideas/bridal-shower/all',
            id: 'fr-fr_bridal_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday photoshoot ideas',
              id: 'navbar_browse_paths.ideas.birthday_photoshoot_ideas'
            }),
            url: '/fr/ideas/birthday-photo-shoot/all',
            id: 'fr-fr_birthday_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Boudoir photoshoot ideas',
              id: 'navbar_browse_paths.ideas.boudoir_photoshoot_ideas'
            }),
            url: '/fr/ideas/boudoir-photo-shoot/all',
            id: 'fr-fr_boudoir_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Couples photoshoot ideas',
              id: 'navbar_browse_paths.ideas.couples_photoshoot_ideas'
            }),
            url: '/fr/ideas/couples-photo-shoot/all',
            id: 'fr-fr_couples_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Spring photoshoot ideas',
              id: 'navbar_browse_paths.ideas.spring_photoshoot_ideas'
            }),
            url: '/fr/ideas/spring-photo-shoot/all',
            id: 'fr-fr_spring_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Outdoor photoshoot ideas',
              id: 'navbar_browse_paths.ideas.outdoor_photoshoot_ideas'
            }),
            url: '/fr/ideas/outdoor-photo-shoot/all',
            id: 'fr-fr_outdoor_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Summer photoshoot ideas',
              id: 'navbar_browse_paths.ideas.summer_photoshoot_ideas'
            }),
            url: '/fr/ideas/summer-photo-shoot/all',
            id: 'fr-fr_summer_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Black and white photoshoot ideas',
              id: 'navbar_browse_paths.ideas.black_and_white_photoshoot_ideas'
            }),
            url: '/fr/ideas/black-and-white-photo-shoot/all',
            id: 'fr-fr_black_and_white_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pink photoshoot ideas',
              id: 'navbar_browse_paths.ideas.pink_photoshoot_ideas'
            }),
            url: '/fr/ideas/pink-photo-shoot/all',
            id: 'fr-fr_pink_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.ideas.see_all'
            }),
            url: '/fr/ideas/all',
            id: 'fr-fr_see_all_ideas'
          }
        ]
      }
    },
    /**
     ***************************************************
     * UNITED KINGDOM
     *******************************
     */
    'en-gb': {
      locations: {
        display: intl.formatMessage({
          defaultMessage: 'Locations',
          id: 'navbar_browse_paths.locations'
        }),
        id: 'en-gb_locations',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'London',
              id: 'navbar_browse_paths.locations.london'
            }),
            url: '/uk/venues/gb/greater-london--england',
            id: 'en-gb_london',
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Manchester',
              id: 'navbar_browse_paths.locations.manchester'
            }),
            url: '/uk/venues/gb/greater-manchester--england',
            id: 'en-gb_manchester',
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Surrey',
              id: 'navbar_browse_paths.locations.surrey'
            }),
            url: '/uk/venues/gb/surrey--england',
            id: 'en-gb_surrey'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Glasgow',
              id: 'navbar_browse_paths.locations.glasgow'
            }),
            url: '/uk/venues/gb/glasgow-city--scotland',
            id: 'en-gb_glasgow'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Edinburgh',
              id: 'navbar_browse_paths.locations.edinburgh'
            }),
            url: '/uk/venues/gb/edinburgh--scotland',
            id: 'en-gb_edinburgh'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bristol',
              id: 'navbar_browse_paths.locations.bristol'
            }),
            url: '/uk/venues/gb/bristol-city--england',
            id: 'en-gb_bristol'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Brighton and Hove',
              id: 'navbar_browse_paths.locations.brighton_and_hove'
            }),
            url: '/uk/venues/gb/brighton-and-hove--england',
            id: 'en-gb_brighton_and_hove'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Nottingham',
              id: 'navbar_browse_paths.locations.nottingham'
            }),
            url: '/uk/venues/gb/nottingham--england',
            id: 'en-gb_nottingham'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Leicester',
              id: 'navbar_browse_paths.locations.leicester'
            }),
            url: '/uk/venues/gb/leicester--england',
            id: 'en-gb_leicester'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Essex',
              id: 'navbar_browse_paths.locations.essex'
            }),
            url: '/uk/venues/gb/essex--england',
            id: 'en-gb_essex'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'West Midlands',
              id: 'navbar_browse_paths.locations.west_midlands'
            }),
            url: '/uk/venues/gb/west-midlands--england',
            id: 'en-gb_west_midlands'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.locations.see_all'
            }),
            url: '/uk/venues/locations',
            id: 'en-gb_see_all_locations'
          }
        ]
      },
      activities: {
        display: intl.formatMessage({
          defaultMessage: 'Activities',
          id: 'navbar_browse_paths.activities'
        }),
        id: 'en-gb_activities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photo Shoot',
              id: 'navbar_browse_paths.activities.photo_shoot'
            }),
            url: '/uk/plan/photo-shoot',
            id: 'en-gb_photo_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Video Shoot',
              id: 'navbar_browse_paths.activities.video_shoot'
            }),
            url: '/uk/plan/video-shoot',
            id: 'en-gb_video_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Meeting',
              id: 'navbar_browse_paths.activities.meeting'
            }),
            url: '/uk/plan/meeting',
            id: 'en-gb_meeting'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party',
              id: 'navbar_browse_paths.activities.party'
            }),
            url: '/uk/plan/party',
            id: 'en-gb_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Workshop',
              id: 'navbar_browse_paths.activities.workshop'
            }),
            url: '/uk/plan/workshop',
            id: 'en-gb_workshop'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby Shower',
              id: 'navbar_browse_paths.activities.baby_shower'
            }),
            url: '/uk/plan/baby-shower',
            id: 'en-gb_baby_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Retreat',
              id: 'navbar_browse_paths.activities.retreat'
            }),
            url: '/uk/plan/retreat',
            id: 'en-gb_retreat'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Dinner',
              id: 'navbar_browse_paths.activities.dinner'
            }),
            url: '/uk/plan/dinner',
            id: 'en-gb_dinner'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Training',
              id: 'navbar_browse_paths.activities.training'
            }),
            url: '/uk/plan/training',
            id: 'en-gb_training'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Wedding',
              id: 'navbar_browse_paths.activities.wedding'
            }),
            url: '/uk/plan/wedding',
            id: 'en-gb_wedding'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday Party',
              id: 'navbar_browse_paths.activities.birthday_party'
            }),
            url: '/uk/plan/birthday-party',
            id: 'en-gb_birthday_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal Shower',
              id: 'navbar_browse_paths.activities.bridal_shower'
            }),
            url: '/uk/plan/bridal-shower',
            id: 'en-gb_bridal_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.activities.see_all'
            }),
            url: '/uk/plan/activities',
            id: 'en-gb_see_all_activities'
          }
        ]
      },
      spaceTypes: {
        display: intl.formatMessage({
          defaultMessage: 'Space Types',
          id: 'navbar_browse_paths.space_types'
        }),
        id: 'en-gb_space_types',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'House',
              id: 'navbar_browse_paths.space_types.house'
            }),
            url: '/uk/plan/house',
            id: 'en-gb_house'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bar',
              id: 'navbar_browse_paths.space_types.bar'
            }),
            url: '/uk/plan/bar',
            id: 'en-gb_bar'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Garage',
              id: 'navbar_browse_paths.space_types.garage'
            }),
            url: '/uk/plan/garage',
            id: 'en-gb_garage'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Warehouse',
              id: 'navbar_browse_paths.space_types.warehouse'
            }),
            url: '/uk/plan/warehouse',
            id: 'en-gb_warehouse'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cabin',
              id: 'navbar_browse_paths.space_types.cabin'
            }),
            url: '/uk/plan/ukbin',
            id: 'en-gb_cabin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Movie Theater',
              id: 'navbar_browse_paths.space_types.movie_theater'
            }),
            url: '/uk/plan/movie-theater',
            id: 'en-gb_movie_theater'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Mansion',
              id: 'navbar_browse_paths.space_types.mansion'
            }),
            url: '/uk/plan/mansion',
            id: 'en-gb_mansion'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Community Center',
              id: 'navbar_browse_paths.space_types.community_center'
            }),
            url: '/uk/plan/community-center',
            id: 'en-gb_community_center'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Castle',
              id: 'navbar_browse_paths.space_types.castle'
            }),
            url: '/uk/plan/ukstle',
            id: 'en-gb_castle'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Basketball Court',
              id: 'navbar_browse_paths.space_types.basketball-court'
            }),
            url: '/uk/plan/basketball-court',
            id: 'en-gb_basketball_court'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Commercial Kitchen',
              id: 'navbar_browse_paths.space_types.commercial_kitchen'
            }),
            url: '/uk/plan/commercial-kitchen',
            id: 'en-gb_commercial_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Barn',
              id: 'navbar_browse_paths.space_types.barn'
            }),
            url: '/uk/plan/barn',
            id: 'en-gb_barn'
          },
        ]
      },
      amenities: {
        display: intl.formatMessage({
          defaultMessage: 'Amenities',
          id: 'navbar_browse_paths.amenities'
        }),
        id: 'en-gb_amenities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Kitchen',
              id: 'navbar_browse_paths.amenities.kitchen'
            }),
            url: '/uk/plan/kitchen',
            id: 'en-gb_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Lounge',
              id: 'navbar_browse_paths.amenities.lounge'
            }),
            url: '/uk/plan/lounge',
            id: 'en-gb_lounge'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cyclorama',
              id: 'navbar_browse_paths.amenities.cyclorama'
            }),
            url: '/uk/plan/cyclorama',
            id: 'en-gb_cyclorama'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Piano',
              id: 'navbar_browse_paths.amenities.piano'
            }),
            url: '/uk/plan/piano',
            id: 'en-gb_piano'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pool',
              id: 'navbar_browse_paths.amenities.pool'
            }),
            url: '/uk/plan/pool',
            id: 'en-gb_pool'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bathtub',
              id: 'navbar_browse_paths.amenities.bathtub'
            }),
            url: '/uk/plan/bathtub',
            id: 'en-gb_bathtub'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Patio',
              id: 'navbar_browse_paths.amenities.patio'
            }),
            url: '/uk/plan/patio',
            id: 'en-gb_patio'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Green Screen',
              id: 'navbar_browse_paths.amenities.green_screen'
            }),
            url: '/uk/plan/green-screen',
            id: 'en-gb_green_screen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Deck',
              id: 'navbar_browse_paths.amenities.deck'
            }),
            url: '/uk/plan/deck',
            id: 'en-gb_deck'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fireplace',
              id: 'navbar_browse_paths.amenities.fireplace'
            }),
            url: '/uk/plan/fireplace',
            id: 'en-gb_fireplace'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Grill',
              id: 'navbar_browse_paths.amenities.grill'
            }),
            url: '/uk/plan/grill',
            id: 'en-gb_grill'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fire Pit',
              id: 'navbar_browse_paths.amenities.fire_pit'
            }),
            url: '/uk/plan/fire-pit',
            id: 'en-gb_fire_pit'
          },
        ]
      },
      ideas: {
        display: intl.formatMessage({
          defaultMessage: 'Ideas',
          id: 'navbar_browse_paths.ideas'
        }),
        id: 'en-gb_ideas',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photoshoot ideas',
              id: 'navbar_browse_paths.ideas.photoshoot_ideas'
            }),
            url: '/uk/ideas/photo-shoot/all',
            id: 'en-gb_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby shower ideas',
              id: 'navbar_browse_paths.ideas.baby_shower_ideas'
            }),
            url: '/uk/ideas/baby-shower/all',
            id: 'en-gb_baby_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party ideas',
              id: 'navbar_browse_paths.ideas.party_ideas'
            }),
            url: '/uk/ideas/party/all',
            id: 'en-gb_party_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal shower ideas',
              id: 'navbar_browse_paths.ideas.bridal_shower_ideas'
            }),
            url: '/uk/ideas/bridal-shower/all',
            id: 'en-gb_bridal_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday photoshoot ideas',
              id: 'navbar_browse_paths.ideas.birthday_photoshoot_ideas'
            }),
            url: '/uk/ideas/birthday-photo-shoot/all',
            id: 'en-gb_birthday_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Boudoir photoshoot ideas',
              id: 'navbar_browse_paths.ideas.boudoir_photoshoot_ideas'
            }),
            url: '/uk/ideas/boudoir-photo-shoot/all',
            id: 'en-gb_boudoir_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Couples photoshoot ideas',
              id: 'navbar_browse_paths.ideas.couples_photoshoot_ideas'
            }),
            url: '/uk/ideas/couples-photo-shoot/all',
            id: 'en-gb_couples_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Spring photoshoot ideas',
              id: 'navbar_browse_paths.ideas.spring_photoshoot_ideas'
            }),
            url: '/uk/ideas/spring-photo-shoot/all',
            id: 'en-gb_spring_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Outdoor photoshoot ideas',
              id: 'navbar_browse_paths.ideas.outdoor_photoshoot_ideas'
            }),
            url: '/uk/ideas/outdoor-photo-shoot/all',
            id: 'en-gb_outdoor_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Summer photoshoot ideas',
              id: 'navbar_browse_paths.ideas.summer_photoshoot_ideas'
            }),
            url: '/uk/ideas/summer-photo-shoot/all',
            id: 'en-gb_summer_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Black and white photoshoot ideas',
              id: 'navbar_browse_paths.ideas.black_and_white_photoshoot_ideas'
            }),
            url: '/uk/ideas/black-and-white-photo-shoot/all',
            id: 'en-gb_black_and_white_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pink photoshoot ideas',
              id: 'navbar_browse_paths.ideas.pink_photoshoot_ideas'
            }),
            url: '/uk/ideas/pink-photo-shoot/all',
            id: 'en-gb_pink_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.ideas.see_all'
            }),
            url: '/uk/ideas/all',
            id: 'en-gb_see_all_ideas'
          }
        ]
      }
    },
    /**
     ***************************************************
     * CANADA
     *******************************
     */
    'en-ca': {
      locations: {
        display: intl.formatMessage({
          defaultMessage: 'Locations',
          id: 'navbar_browse_paths.locations'
        }),
        id: 'en-ca_locations',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Toronto',
              id: 'navbar_browse_paths.locations.toronto'
            }),
            url: '/ca/venues/ca/toronto--on',
            id: 'en-ca_toronto'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Vancouver',
              id: 'navbar_browse_paths.locations.vancouver'
            }),
            url: '/ca/venues/ca/vancouver--bc',
            id: 'en-ca_vancouver'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'North Vancouver',
              id: 'navbar_browse_paths.locations.north_vancouver'
            }),
            url: '/ca/venues/ca/north-vancouver--bc',
            id: 'en-ca_north_vancouver'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Calgary',
              id: 'navbar_browse_paths.locations.calgary'
            }),
            url: '/ca/venues/ca/calgary--ab',
            id: 'en-ca_calgary'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Edmonton',
              id: 'navbar_browse_paths.locations.edmonton'
            }),
            url: '/ca/venues/ca/edmonton--ab',
            id: 'en-ca_edmonton'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fort Erie',
              id: 'navbar_browse_paths.locations.fort_erie'
            }),
            url: '/ca/venues/ca/fort-erie--on',
            id: 'en-ca_fort_erie'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Mississauga',
              id: 'navbar_browse_paths.locations.mississauga'
            }),
            url: '/ca/venues/ca/mississauga--on',
            id: 'en-ca_mississauga'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Richmond Hill',
              id: 'navbar_browse_paths.locations.richmond_hill'
            }),
            url: '/ca/venues/ca/richmond-hill--on',
            id: 'en-ca_richmond_hill'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Surrey',
              id: 'navbar_browse_paths.locations.surrey'
            }),
            url: '/ca/venues/ca/surrey--bc',
            id: 'en-ca_surrey'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Vaughan',
              id: 'navbar_browse_paths.locations.vaughan'
            }),
            url: '/ca/venues/ca/vaughan--on',
            id: 'en-ca_vaughan'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.locations.see_all'
            }),
            url: '/ca/venues/locations',
            id: 'en-ca_see_all_locations'
          }
        ]
      },
      activities: {
        display: intl.formatMessage({
          defaultMessage: 'Activities',
          id: 'navbar_browse_paths.activities'
        }),
        id: 'en-ca_activities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photo Shoot',
              id: 'navbar_browse_paths.activities.photo_shoot'
            }),
            url: '/ca/plan/photo-shoot',
            id: 'en-ca_photo_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Video Shoot',
              id: 'navbar_browse_paths.activities.video_shoot'
            }),
            url: '/ca/plan/video-shoot',
            id: 'en-ca_video_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Meeting',
              id: 'navbar_browse_paths.activities.meeting'
            }),
            url: '/ca/plan/meeting',
            id: 'en-ca_meeting'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party',
              id: 'navbar_browse_paths.activities.party'
            }),
            url: '/ca/plan/party',
            id: 'en-ca_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Workshop',
              id: 'navbar_browse_paths.activities.workshop'
            }),
            url: '/ca/plan/workshop',
            id: 'en-ca_workshop'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby Shower',
              id: 'navbar_browse_paths.activities.baby_shower'
            }),
            url: '/ca/plan/baby-shower',
            id: 'en-ca_baby_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Retreat',
              id: 'navbar_browse_paths.activities.retreat'
            }),
            url: '/ca/plan/retreat',
            id: 'en-ca_retreat'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Dinner',
              id: 'navbar_browse_paths.activities.dinner'
            }),
            url: '/ca/plan/dinner',
            id: 'en-ca_dinner'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Training',
              id: 'navbar_browse_paths.activities.training'
            }),
            url: '/ca/plan/training',
            id: 'en-ca_training'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Wedding',
              id: 'navbar_browse_paths.activities.wedding'
            }),
            url: '/ca/plan/wedding',
            id: 'en-ca_wedding'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday Party',
              id: 'navbar_browse_paths.activities.birthday_party'
            }),
            url: '/ca/plan/birthday-party',
            id: 'en-ca_birthday_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal Shower',
              id: 'navbar_browse_paths.activities.bridal_shower'
            }),
            url: '/ca/plan/bridal-shower',
            id: 'en-ca_bridal_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.activities.see_all'
            }),
            url: '/ca/plan/activities',
            id: 'en-ca_see_all_activities'
          }
        ]
      },
      spaceTypes: {
        display: intl.formatMessage({
          defaultMessage: 'Space Types',
          id: 'navbar_browse_paths.space_types'
        }),
        id: 'en-ca_space_types',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'House',
              id: 'navbar_browse_paths.space_types.house'
            }),
            url: '/ca/plan/house',
            id: 'en-ca_house'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bar',
              id: 'navbar_browse_paths.space_types.bar'
            }),
            url: '/ca/plan/bar',
            id: 'en-ca_bar'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Garage',
              id: 'navbar_browse_paths.space_types.garage'
            }),
            url: '/ca/plan/garage',
            id: 'en-ca_garage'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Warehouse',
              id: 'navbar_browse_paths.space_types.warehouse'
            }),
            url: '/ca/plan/warehouse',
            id: 'en-ca_warehouse'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cabin',
              id: 'navbar_browse_paths.space_types.cabin'
            }),
            url: '/ca/plan/cabin',
            id: 'en-ca_cabin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Movie Theater',
              id: 'navbar_browse_paths.space_types.movie_theater'
            }),
            url: '/ca/plan/movie-theater',
            id: 'en-ca_movie_theater'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Mansion',
              id: 'navbar_browse_paths.space_types.mansion'
            }),
            url: '/ca/plan/mansion',
            id: 'en-ca_mansion'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Community Center',
              id: 'navbar_browse_paths.space_types.community_center'
            }),
            url: '/ca/plan/community-center',
            id: 'en-ca_community_center'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Castle',
              id: 'navbar_browse_paths.space_types.castle'
            }),
            url: '/ca/plan/castle',
            id: 'en-ca_castle'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Basketball Court',
              id: 'navbar_browse_paths.space_types.basketball-court'
            }),
            url: '/ca/plan/basketball-court',
            id: 'en-ca_basketball_court'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Commercial Kitchen',
              id: 'navbar_browse_paths.space_types.commercial_kitchen'
            }),
            url: '/ca/plan/commercial-kitchen',
            id: 'en-ca_commercial_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Barn',
              id: 'navbar_browse_paths.space_types.barn'
            }),
            url: '/ca/plan/barn',
            id: 'en-ca_barn'
          },
        ]
      },
      amenities: {
        display: intl.formatMessage({
          defaultMessage: 'Amenities',
          id: 'navbar_browse_paths.amenities'
        }),
        id: 'en-ca_amenities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Kitchen',
              id: 'navbar_browse_paths.amenities.kitchen'
            }),
            url: '/ca/plan/kitchen',
            id: 'en-ca_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Lounge',
              id: 'navbar_browse_paths.amenities.lounge'
            }),
            url: '/ca/plan/lounge',
            id: 'en-ca_lounge'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cyclorama',
              id: 'navbar_browse_paths.amenities.cyclorama'
            }),
            url: '/ca/plan/cyclorama',
            id: 'en-ca_cyclorama'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Piano',
              id: 'navbar_browse_paths.amenities.piano'
            }),
            url: '/ca/plan/piano',
            id: 'en-ca_piano'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pool',
              id: 'navbar_browse_paths.amenities.pool'
            }),
            url: '/ca/plan/pool',
            id: 'en-ca_pool'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bathtub',
              id: 'navbar_browse_paths.amenities.bathtub'
            }),
            url: '/ca/plan/bathtub',
            id: 'en-ca_bathtub'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Patio',
              id: 'navbar_browse_paths.amenities.patio'
            }),
            url: '/ca/plan/patio',
            id: 'en-ca_patio'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Green Screen',
              id: 'navbar_browse_paths.amenities.green_screen'
            }),
            url: '/ca/plan/green-screen',
            id: 'en-ca_green_screen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Deck',
              id: 'navbar_browse_paths.amenities.deck'
            }),
            url: '/ca/plan/deck',
            id: 'en-ca_deck'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fireplace',
              id: 'navbar_browse_paths.amenities.fireplace'
            }),
            url: '/ca/plan/fireplace',
            id: 'en-ca_fireplace'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Grill',
              id: 'navbar_browse_paths.amenities.grill'
            }),
            url: '/ca/plan/grill',
            id: 'en-ca_grill'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fire Pit',
              id: 'navbar_browse_paths.amenities.fire_pit'
            }),
            url: '/ca/plan/fire-pit',
            id: 'en-ca_fire_pit'
          },
        ]
      },
      ideas: {
        display: intl.formatMessage({
          defaultMessage: 'Ideas',
          id: 'navbar_browse_paths.ideas'
        }),
        id: 'en-ca_ideas',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photoshoot ideas',
              id: 'navbar_browse_paths.ideas.photoshoot_ideas'
            }),
            url: '/ca/ideas/photo-shoot/all',
            id: 'en-ca_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby shower ideas',
              id: 'navbar_browse_paths.ideas.baby_shower_ideas'
            }),
            url: '/ca/ideas/baby-shower/all',
            id: 'en-ca_baby_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party ideas',
              id: 'navbar_browse_paths.ideas.party_ideas'
            }),
            url: '/ca/ideas/party/all',
            id: 'en-ca_party_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal shower ideas',
              id: 'navbar_browse_paths.ideas.bridal_shower_ideas'
            }),
            url: '/ca/ideas/bridal-shower/all',
            id: 'en-ca_bridal_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday photoshoot ideas',
              id: 'navbar_browse_paths.ideas.birthday_photoshoot_ideas'
            }),
            url: '/ca/ideas/birthday-photo-shoot/all',
            id: 'en-ca_birthday_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Boudoir photoshoot ideas',
              id: 'navbar_browse_paths.ideas.boudoir_photoshoot_ideas'
            }),
            url: '/ca/ideas/boudoir-photo-shoot/all',
            id: 'en-ca_boudoir_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Couples photoshoot ideas',
              id: 'navbar_browse_paths.ideas.couples_photoshoot_ideas'
            }),
            url: '/ca/ideas/couples-photo-shoot/all',
            id: 'en-ca_couples_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Spring photoshoot ideas',
              id: 'navbar_browse_paths.ideas.spring_photoshoot_ideas'
            }),
            url: '/ca/ideas/spring-photo-shoot/all',
            id: 'en-ca_spring_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Outdoor photoshoot ideas',
              id: 'navbar_browse_paths.ideas.outdoor_photoshoot_ideas'
            }),
            url: '/ca/ideas/outdoor-photo-shoot/all',
            id: 'en-ca_outdoor_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Summer photoshoot ideas',
              id: 'navbar_browse_paths.ideas.summer_photoshoot_ideas'
            }),
            url: '/ca/ideas/summer-photo-shoot/all',
            id: 'en-ca_summer_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Black and white photoshoot ideas',
              id: 'navbar_browse_paths.ideas.black_and_white_photoshoot_ideas'
            }),
            url: '/ca/ideas/black-and-white-photo-shoot/all',
            id: 'en-ca_black_and_white_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pink photoshoot ideas',
              id: 'navbar_browse_paths.ideas.pink_photoshoot_ideas'
            }),
            url: '/ca/ideas/pink-photo-shoot/all',
            id: 'en-ca_pink_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.ideas.see_all'
            }),
            url: '/ca/ideas/all',
            id: 'en-ca_see_all_ideas'
          }
        ]
      }
    },
    /**
     ***************************************************
     * AUSTRALIA
     *******************************
     */
    'en-au': {
      locations: {
        display: intl.formatMessage({
          defaultMessage: 'Locations',
          id: 'navbar_browse_paths.locations'
        }),
        id: 'en-au_locations',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Sydney',
              id: 'navbar_browse_paths.locations.sydney'
            }),
            url: '/au/venues/au/sydney--nsw',
            id: 'en-au_sydney'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Melbourne',
              id: 'navbar_browse_paths.locations.melbourne'
            }),
            url: '/au/venues/au/melbourne--vic',
            id: 'en-au_melbourne'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Brookvale',
              id: 'navbar_browse_paths.locations.brookvale'
            }),
            url: '/au/venues/au/brookvale--nsw',
            id: 'en-au_brookvale'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'North Sydney',
              id: 'navbar_browse_paths.locations.north_sydney'
            }),
            url: '/au/venues/au/north-sydney--nsw',
            id: 'en-au_north_sydney'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'South Melbourne',
              id: 'navbar_browse_paths.locations.south_melbourne'
            }),
            url: '/au/venues/au/south-melbourne--vic',
            id: 'en-au_south_melbourne'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Newtown',
              id: 'navbar_browse_paths.locations.newtown'
            }),
            url: '/au/venues/au/newtown--nsw',
            id: 'en-au_newtown'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Paddington',
              id: 'navbar_browse_paths.locations.paddington'
            }),
            url: '/au/venues/au/paddington--nsw',
            id: 'en-au_paddington'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fitzroy',
              id: 'navbar_browse_paths.locations.fitzroy'
            }),
            url: '/au/venues/au/fitzroy--vic',
            id: 'en-au_fitzroy'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Glebe',
              id: 'navbar_browse_paths.locations.glebe'
            }),
            url: '/au/venues/au/glebe--nsw',
            id: 'en-au_glebe'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'St Kilda',
              id: 'navbar_browse_paths.locations.st_kilda'
            }),
            url: '/au/venues/au/st-kilda--vic',
            id: 'en-au_st_kilda'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Richmond',
              id: 'navbar_browse_paths.locations.richmond'
            }),
            url: '/au/venues/au/richmond--vic',
            id: 'en-au_richmond'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.locations.see_all'
            }),
            url: '/au/venues/locations',
            id: 'en-au_see_all_locations'
          }
        ]
      },
      activities: {
        display: intl.formatMessage({
          defaultMessage: 'Activities',
          id: 'navbar_browse_paths.activities'
        }),
        id: 'en-au_activities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photo Shoot',
              id: 'navbar_browse_paths.activities.photo_shoot'
            }),
            url: '/au/plan/photo-shoot',
            id: 'en-au_photo_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Video Shoot',
              id: 'navbar_browse_paths.activities.video_shoot'
            }),
            url: '/au/plan/video-shoot',
            id: 'en-au_video_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Meeting',
              id: 'navbar_browse_paths.activities.meeting'
            }),
            url: '/au/plan/meeting',
            id: 'en-au_meeting'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party',
              id: 'navbar_browse_paths.activities.party'
            }),
            url: '/au/plan/party',
            id: 'en-au_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Workshop',
              id: 'navbar_browse_paths.activities.workshop'
            }),
            url: '/au/plan/workshop',
            id: 'en-au_workshop'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby Shower',
              id: 'navbar_browse_paths.activities.baby_shower'
            }),
            url: '/au/plan/baby-shower',
            id: 'en-au_baby_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Retreat',
              id: 'navbar_browse_paths.activities.retreat'
            }),
            url: '/au/plan/retreat',
            id: 'en-au_retreat'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Dinner',
              id: 'navbar_browse_paths.activities.dinner'
            }),
            url: '/au/plan/dinner',
            id: 'en-au_dinner'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Training',
              id: 'navbar_browse_paths.activities.training'
            }),
            url: '/au/plan/training',
            id: 'en-au_training'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Wedding',
              id: 'navbar_browse_paths.activities.wedding'
            }),
            url: '/au/plan/wedding',
            id: 'en-au_wedding'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday Party',
              id: 'navbar_browse_paths.activities.birthday_party'
            }),
            url: '/au/plan/birthday-party',
            id: 'en-au_birthday_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal Shower',
              id: 'navbar_browse_paths.activities.bridal_shower'
            }),
            url: '/au/plan/bridal-shower',
            id: 'en-au_bridal_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.activities.see_all'
            }),
            url: '/au/plan/activities',
            id: 'en-au_see_all_activities'
          }
        ]
      },
      spaceTypes: {
        display: intl.formatMessage({
          defaultMessage: 'Space Types',
          id: 'navbar_browse_paths.space_types'
        }),
        id: 'en-au_space_types',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'House',
              id: 'navbar_browse_paths.space_types.house'
            }),
            url: '/au/plan/house',
            id: 'en-au_house'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bar',
              id: 'navbar_browse_paths.space_types.bar'
            }),
            url: '/au/plan/bar',
            id: 'en-au_bar'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Garage',
              id: 'navbar_browse_paths.space_types.garage'
            }),
            url: '/au/plan/garage',
            id: 'en-au_garage'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Warehouse',
              id: 'navbar_browse_paths.space_types.warehouse'
            }),
            url: '/au/plan/warehouse',
            id: 'en-au_warehouse'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cabin',
              id: 'navbar_browse_paths.space_types.cabin'
            }),
            url: '/au/plan/cabin',
            id: 'en-au_cabin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Movie Theater',
              id: 'navbar_browse_paths.space_types.movie_theater'
            }),
            url: '/au/plan/movie-theater',
            id: 'en-au_movie_theater'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Mansion',
              id: 'navbar_browse_paths.space_types.mansion'
            }),
            url: '/au/plan/mansion',
            id: 'en-au_mansion'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Community Center',
              id: 'navbar_browse_paths.space_types.community_center'
            }),
            url: '/au/plan/community-center',
            id: 'en-au_community_center'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Castle',
              id: 'navbar_browse_paths.space_types.castle'
            }),
            url: '/au/plan/castle',
            id: 'en-au_castle'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Basketball Court',
              id: 'navbar_browse_paths.space_types.basketball-court'
            }),
            url: '/au/plan/basketball-court',
            id: 'en-au_basketball_court'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Commercial Kitchen',
              id: 'navbar_browse_paths.space_types.commercial_kitchen'
            }),
            url: '/au/plan/commercial-kitchen',
            id: 'en-au_commercial_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Barn',
              id: 'navbar_browse_paths.space_types.barn'
            }),
            url: '/au/plan/barn',
            id: 'en-au_barn'
          },
        ]
      },
      amenities: {
        display: intl.formatMessage({
          defaultMessage: 'Amenities',
          id: 'navbar_browse_paths.amenities'
        }),
        id: 'en-au_amenities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Kitchen',
              id: 'navbar_browse_paths.amenities.kitchen'
            }),
            url: '/au/plan/kitchen',
            id: 'en-au_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Lounge',
              id: 'navbar_browse_paths.amenities.lounge'
            }),
            url: '/au/plan/lounge',
            id: 'en-au_lounge'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cyclorama',
              id: 'navbar_browse_paths.amenities.cyclorama'
            }),
            url: '/au/plan/cyclorama',
            id: 'en-au_cyclorama'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Piano',
              id: 'navbar_browse_paths.amenities.piano'
            }),
            url: '/au/plan/piano',
            id: 'en-au_piano'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pool',
              id: 'navbar_browse_paths.amenities.pool'
            }),
            url: '/au/plan/pool',
            id: 'en-au_pool'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bathtub',
              id: 'navbar_browse_paths.amenities.bathtub'
            }),
            url: '/au/plan/bathtub',
            id: 'en-au_bathtub'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Patio',
              id: 'navbar_browse_paths.amenities.patio'
            }),
            url: '/au/plan/patio',
            id: 'en-au_patio'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Green Screen',
              id: 'navbar_browse_paths.amenities.green_screen'
            }),
            url: '/au/plan/green-screen',
            id: 'en-au_green_screen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Deck',
              id: 'navbar_browse_paths.amenities.deck'
            }),
            url: '/au/plan/deck',
            id: 'en-au_deck'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fireplace',
              id: 'navbar_browse_paths.amenities.fireplace'
            }),
            url: '/au/plan/fireplace',
            id: 'en-au_fireplace'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Grill',
              id: 'navbar_browse_paths.amenities.grill'
            }),
            url: '/au/plan/grill',
            id: 'en-au_grill'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fire Pit',
              id: 'navbar_browse_paths.amenities.fire_pit'
            }),
            url: '/au/plan/fire-pit',
            id: 'en-au_fire_pit'
          },
        ]
      },
      ideas: {
        display: intl.formatMessage({
          defaultMessage: 'Ideas',
          id: 'navbar_browse_paths.ideas'
        }),
        id: 'en-au_ideas',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photoshoot ideas',
              id: 'navbar_browse_paths.ideas.photoshoot_ideas'
            }),
            url: '/au/ideas/photo-shoot/all',
            id: 'en-au_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby shower ideas',
              id: 'navbar_browse_paths.ideas.baby_shower_ideas'
            }),
            url: '/au/ideas/baby-shower/all',
            id: 'en-au_baby_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party ideas',
              id: 'navbar_browse_paths.ideas.party_ideas'
            }),
            url: '/au/ideas/party/all',
            id: 'en-au_party_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal shower ideas',
              id: 'navbar_browse_paths.ideas.bridal_shower_ideas'
            }),
            url: '/au/ideas/bridal-shower/all',
            id: 'en-au_bridal_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday photoshoot ideas',
              id: 'navbar_browse_paths.ideas.birthday_photoshoot_ideas'
            }),
            url: '/au/ideas/birthday-photo-shoot/all',
            id: 'en-au_birthday_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Boudoir photoshoot ideas',
              id: 'navbar_browse_paths.ideas.boudoir_photoshoot_ideas'
            }),
            url: '/au/ideas/boudoir-photo-shoot/all',
            id: 'en-au_boudoir_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Couples photoshoot ideas',
              id: 'navbar_browse_paths.ideas.couples_photoshoot_ideas'
            }),
            url: '/au/ideas/couples-photo-shoot/all',
            id: 'en-au_couples_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Spring photoshoot ideas',
              id: 'navbar_browse_paths.ideas.spring_photoshoot_ideas'
            }),
            url: '/au/ideas/spring-photo-shoot/all',
            id: 'en-au_spring_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Outdoor photoshoot ideas',
              id: 'navbar_browse_paths.ideas.outdoor_photoshoot_ideas'
            }),
            url: '/au/ideas/outdoor-photo-shoot/all',
            id: 'en-au_outdoor_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Summer photoshoot ideas',
              id: 'navbar_browse_paths.ideas.summer_photoshoot_ideas'
            }),
            url: '/au/ideas/summer-photo-shoot/all',
            id: 'en-au_summer_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Black and white photoshoot ideas',
              id: 'navbar_browse_paths.ideas.black_and_white_photoshoot_ideas'
            }),
            url: '/au/ideas/black-and-white-photo-shoot/all',
            id: 'en-au_black_and_white_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pink photoshoot ideas',
              id: 'navbar_browse_paths.ideas.pink_photoshoot_ideas'
            }),
            url: '/au/ideas/pink-photo-shoot/all',
            id: 'en-au_pink_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.ideas.see_all'
            }),
            url: '/au/ideas/all',
            id: 'en-au_see_all_ideas'
          }
        ]
      }
    },
    /**
     ***************************************************
     * GERMANY
     *******************************
     */
    'de-de': {
      locations: {
        display: intl.formatMessage({
          defaultMessage: 'Locations',
          id: 'navbar_browse_paths.locations'
        }),
        id: 'de-de_locations',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Berlin',
              id: 'navbar_browse_paths.locations.berlin'
            }),
            url: '/de/venues/de/berlin--be',
            id: 'de-de_berlin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.locations.see_all'
            }),
            url: '/de/venues/locations',
            id: 'de-de_see_all_locations'
          }
        ]
      },
      activities: {
        display: intl.formatMessage({
          defaultMessage: 'Activities',
          id: 'navbar_browse_paths.activities'
        }),
        id: 'de-de_activities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photo Shoot',
              id: 'navbar_browse_paths.activities.photo_shoot'
            }),
            url: '/de/plan/photo-shoot',
            id: 'de-de_photo_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Film Shoot',
              id: 'navbar_browse_paths.activities.film_shoot'
            }),
            url: '/de/plan/film-shoot',
            id: 'de-de_video_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Meeting',
              id: 'navbar_browse_paths.activities.meeting'
            }),
            url: '/de/plan/meeting',
            id: 'de-de_meeting'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party',
              id: 'navbar_browse_paths.activities.party'
            }),
            url: '/de/plan/party',
            id: 'de-de_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Workshop',
              id: 'navbar_browse_paths.activities.workshop'
            }),
            url: '/de/plan/workshop',
            id: 'de-de_workshop'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby Shower',
              id: 'navbar_browse_paths.activities.baby_shower'
            }),
            url: '/de/plan/baby-shower',
            id: 'de-de_baby_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Retreat',
              id: 'navbar_browse_paths.activities.retreat'
            }),
            url: '/de/plan/retreat',
            id: 'de-de_retreat'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Dinner',
              id: 'navbar_browse_paths.activities.dinner'
            }),
            url: '/de/plan/dinner',
            id: 'de-de_dinner'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Training',
              id: 'navbar_browse_paths.activities.training'
            }),
            url: '/de/plan/training',
            id: 'de-de_training'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Wedding Reception',
              id: 'navbar_browse_paths.activities.wedding_reception'
            }),
            url: '/de/plan/wedding-reception',
            id: 'de-de_wedding-reception'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday Party',
              id: 'navbar_browse_paths.activities.birthday_party'
            }),
            url: '/de/plan/birthday-party',
            id: 'de-de_birthday_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal Shower',
              id: 'navbar_browse_paths.activities.bridal_shower'
            }),
            url: '/de/plan/bridal-shower',
            id: 'de-de_bridal_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.activities.see_all'
            }),
            url: '/de/plan/activities',
            id: 'de-de_see_all_activities'
          }
        ]
      },
      spaceTypes: {
        display: intl.formatMessage({
          defaultMessage: 'Space Types',
          id: 'navbar_browse_paths.space_types'
        }),
        id: 'de-de_space_types',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'House',
              id: 'navbar_browse_paths.space_types.house'
            }),
            url: '/de/plan/house',
            id: 'de-de_house'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bar',
              id: 'navbar_browse_paths.space_types.bar'
            }),
            url: '/de/plan/bar',
            id: 'de-de_bar'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Garage',
              id: 'navbar_browse_paths.space_types.garage'
            }),
            url: '/de/plan/garage',
            id: 'de-de_garage'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Warehouse',
              id: 'navbar_browse_paths.space_types.warehouse'
            }),
            url: '/de/plan/warehouse',
            id: 'de-de_warehouse'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cabin',
              id: 'navbar_browse_paths.space_types.cabin'
            }),
            url: '/de/plan/cabin',
            id: 'de-de_cabin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Movie Theater',
              id: 'navbar_browse_paths.space_types.movie_theater'
            }),
            url: '/de/plan/movie-theater',
            id: 'de-de_movie_theater'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Mansion',
              id: 'navbar_browse_paths.space_types.mansion'
            }),
            url: '/de/plan/mansion',
            id: 'de-de_mansion'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Community Center',
              id: 'navbar_browse_paths.space_types.community_center'
            }),
            url: '/de/plan/community-center',
            id: 'de-de_community_center'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Castle',
              id: 'navbar_browse_paths.space_types.castle'
            }),
            url: '/de/plan/castle',
            id: 'de-de_castle'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Basketball Court',
              id: 'navbar_browse_paths.space_types.basketball-court'
            }),
            url: '/de/plan/basketball-court',
            id: 'de-de_basketball_court'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Commercial Kitchen',
              id: 'navbar_browse_paths.space_types.commercial_kitchen'
            }),
            url: '/de/plan/commercial-kitchen',
            id: 'de-de_commercial_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Barn',
              id: 'navbar_browse_paths.space_types.barn'
            }),
            url: '/de/plan/barn',
            id: 'de-de_barn'
          },
        ]
      },
      amenities: {
        display: intl.formatMessage({
          defaultMessage: 'Amenities',
          id: 'navbar_browse_paths.amenities'
        }),
        id: 'de-de_amenities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Kitchen',
              id: 'navbar_browse_paths.amenities.kitchen'
            }),
            url: '/de/plan/kitchen',
            id: 'de-de_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Lounge',
              id: 'navbar_browse_paths.amenities.lounge'
            }),
            url: '/de/plan/lounge',
            id: 'de-de_lounge'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cyclorama',
              id: 'navbar_browse_paths.amenities.cyclorama'
            }),
            url: '/de/plan/cyclorama',
            id: 'de-de_cyclorama'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Piano',
              id: 'navbar_browse_paths.amenities.piano'
            }),
            url: '/de/plan/piano',
            id: 'de-de_piano'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pool',
              id: 'navbar_browse_paths.amenities.pool'
            }),
            url: '/de/plan/pool',
            id: 'de-de_pool'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bathtub',
              id: 'navbar_browse_paths.amenities.bathtub'
            }),
            url: '/de/plan/bathtub',
            id: 'de-de_bathtub'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Patio',
              id: 'navbar_browse_paths.amenities.patio'
            }),
            url: '/de/plan/patio',
            id: 'de-de_patio'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Green Screen',
              id: 'navbar_browse_paths.amenities.green_screen'
            }),
            url: '/de/plan/green-screen',
            id: 'de-de_green_screen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Deck',
              id: 'navbar_browse_paths.amenities.deck'
            }),
            url: '/de/plan/deck',
            id: 'de-de_deck'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fireplace',
              id: 'navbar_browse_paths.amenities.fireplace'
            }),
            url: '/de/plan/fireplace',
            id: 'de-de_fireplace'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Grill',
              id: 'navbar_browse_paths.amenities.grill'
            }),
            url: '/de/plan/grill',
            id: 'de-de_grill'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fire Pit',
              id: 'navbar_browse_paths.amenities.fire_pit'
            }),
            url: '/de/plan/fire-pit',
            id: 'de-de_fire_pit'
          },
        ]
      },
      ideas: {
        display: intl.formatMessage({
          defaultMessage: 'Ideas',
          id: 'navbar_browse_paths.ideas'
        }),
        id: 'de-de_ideas',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photoshoot ideas',
              id: 'navbar_browse_paths.ideas.photoshoot_ideas'
            }),
            url: '/de/ideas/photo-shoot/all',
            id: 'de-de_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby shower ideas',
              id: 'navbar_browse_paths.ideas.baby_shower_ideas'
            }),
            url: '/de/ideas/baby-shower/all',
            id: 'de-de_baby_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party ideas',
              id: 'navbar_browse_paths.ideas.party_ideas'
            }),
            url: '/de/ideas/party/all',
            id: 'de-de_party_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal shower ideas',
              id: 'navbar_browse_paths.ideas.bridal_shower_ideas'
            }),
            url: '/de/ideas/bridal-shower/all',
            id: 'de-de_bridal_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday photoshoot ideas',
              id: 'navbar_browse_paths.ideas.birthday_photoshoot_ideas'
            }),
            url: '/de/ideas/birthday-photo-shoot/all',
            id: 'de-de_birthday_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Boudoir photoshoot ideas',
              id: 'navbar_browse_paths.ideas.boudoir_photoshoot_ideas'
            }),
            url: '/de/ideas/boudoir-photo-shoot/all',
            id: 'de-de_boudoir_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Couples photoshoot ideas',
              id: 'navbar_browse_paths.ideas.couples_photoshoot_ideas'
            }),
            url: '/de/ideas/couples-photo-shoot/all',
            id: 'de-de_couples_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Spring photoshoot ideas',
              id: 'navbar_browse_paths.ideas.spring_photoshoot_ideas'
            }),
            url: '/de/ideas/spring-photo-shoot/all',
            id: 'de-de_spring_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Outdoor photoshoot ideas',
              id: 'navbar_browse_paths.ideas.outdoor_photoshoot_ideas'
            }),
            url: '/de/ideas/outdoor-photo-shoot/all',
            id: 'de-de_outdoor_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Summer photoshoot ideas',
              id: 'navbar_browse_paths.ideas.summer_photoshoot_ideas'
            }),
            url: '/de/ideas/summer-photo-shoot/all',
            id: 'de-de_summer_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Black and white photoshoot ideas',
              id: 'navbar_browse_paths.ideas.black_and_white_photoshoot_ideas'
            }),
            url: '/de/ideas/black-and-white-photo-shoot/all',
            id: 'de-de_black_and_white_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pink photoshoot ideas',
              id: 'navbar_browse_paths.ideas.pink_photoshoot_ideas'
            }),
            url: '/de/ideas/pink-photo-shoot/all',
            id: 'de-de_pink_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.ideas.see_all'
            }),
            url: '/de/ideas/all',
            id: 'de-de_see_all_ideas'
          }
        ]
      }
    },
    /**
     ***************************************************
     * SPAIN
     *******************************
     */
    'es-es': {
      locations: {
        display: intl.formatMessage({
          defaultMessage: 'Locations',
          id: 'navbar_browse_paths.locations'
        }),
        id: 'es-es_locations',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Barcelona',
              id: 'navbar_browse_paths.locations.barcelona'
            }),
            url: '/de/venues/es/barcelona--ct',
            id: 'es-es_barcelona'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.locations.see_all'
            }),
            url: '/es/venues/locations',
            id: 'es-es_see_all_locations'
          }
        ]
      },
      activities: {
        display: intl.formatMessage({
          defaultMessage: 'Activities',
          id: 'navbar_browse_paths.activities'
        }),
        id: 'es-es_activities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photo Shoot',
              id: 'navbar_browse_paths.activities.photo_shoot'
            }),
            url: '/es/plan/photo-shoot',
            id: 'es-es_photo_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Film Shoot',
              id: 'navbar_browse_paths.activities.film_shoot'
            }),
            url: '/es/plan/film-shoot',
            id: 'es-es_video_shoot'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Meeting',
              id: 'navbar_browse_paths.activities.meeting'
            }),
            url: '/es/plan/meeting',
            id: 'es-es_meeting'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party',
              id: 'navbar_browse_paths.activities.party'
            }),
            url: '/es/plan/party',
            id: 'es-es_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Workshop',
              id: 'navbar_browse_paths.activities.workshop'
            }),
            url: '/es/plan/workshop',
            id: 'es-es_workshop'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby Shower',
              id: 'navbar_browse_paths.activities.baby_shower'
            }),
            url: '/es/plan/baby-shower',
            id: 'es-es_baby_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Retreat',
              id: 'navbar_browse_paths.activities.retreat'
            }),
            url: '/es/plan/retreat',
            id: 'es-es_retreat'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Dinner',
              id: 'navbar_browse_paths.activities.dinner'
            }),
            url: '/es/plan/dinner',
            id: 'es-es_dinner'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Training',
              id: 'navbar_browse_paths.activities.training'
            }),
            url: '/es/plan/training',
            id: 'es-es_training'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Wedding Reception',
              id: 'navbar_browse_paths.activities.wedding_reception'
            }),
            url: '/es/plan/wedding-reception',
            id: 'es-es_wedding-reception'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday Party',
              id: 'navbar_browse_paths.activities.birthday_party'
            }),
            url: '/es/plan/birthday-party',
            id: 'es-es_birthday_party'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal Shower',
              id: 'navbar_browse_paths.activities.bridal_shower'
            }),
            url: '/es/plan/bridal-shower',
            id: 'es-es_bridal_shower'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.activities.see_all'
            }),
            url: '/es/plan/activities',
            id: 'es-es_see_all_activities'
          }
        ]
      },
      spaceTypes: {
        display: intl.formatMessage({
          defaultMessage: 'Space Types',
          id: 'navbar_browse_paths.space_types'
        }),
        id: 'es-es_space_types',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'House',
              id: 'navbar_browse_paths.space_types.house'
            }),
            url: '/es/plan/house',
            id: 'es-es_house'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bar',
              id: 'navbar_browse_paths.space_types.bar'
            }),
            url: '/es/plan/bar',
            id: 'es-es_bar'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Garage',
              id: 'navbar_browse_paths.space_types.garage'
            }),
            url: '/es/plan/garage',
            id: 'es-es_garage'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Warehouse',
              id: 'navbar_browse_paths.space_types.warehouse'
            }),
            url: '/es/plan/warehouse',
            id: 'es-es_warehouse'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cabin',
              id: 'navbar_browse_paths.space_types.cabin'
            }),
            url: '/es/plan/cabin',
            id: 'es-es_cabin'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Movie Theater',
              id: 'navbar_browse_paths.space_types.movie_theater'
            }),
            url: '/es/plan/movie-theater',
            id: 'es-es_movie_theater'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Mansion',
              id: 'navbar_browse_paths.space_types.mansion'
            }),
            url: '/es/plan/mansion',
            id: 'es-es_mansion'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Community Center',
              id: 'navbar_browse_paths.space_types.community_center'
            }),
            url: '/es/plan/community-center',
            id: 'es-es_community_center'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Castle',
              id: 'navbar_browse_paths.space_types.castle'
            }),
            url: '/es/plan/castle',
            id: 'es-es_castle'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Basketball Court',
              id: 'navbar_browse_paths.space_types.basketball-court'
            }),
            url: '/es/plan/basketball-court',
            id: 'es-es_basketball_court'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Commercial Kitchen',
              id: 'navbar_browse_paths.space_types.commercial_kitchen'
            }),
            url: '/es/plan/commercial-kitchen',
            id: 'es-es_commercial_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Barn',
              id: 'navbar_browse_paths.space_types.barn'
            }),
            url: '/es/plan/barn',
            id: 'es-es_barn'
          },
        ]
      },
      amenities: {
        display: intl.formatMessage({
          defaultMessage: 'Amenities',
          id: 'navbar_browse_paths.amenities'
        }),
        id: 'es-es_amenities',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Kitchen',
              id: 'navbar_browse_paths.amenities.kitchen'
            }),
            url: '/es/plan/kitchen',
            id: 'es-es_kitchen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Lounge',
              id: 'navbar_browse_paths.amenities.lounge'
            }),
            url: '/es/plan/lounge',
            id: 'es-es_lounge'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Cyclorama',
              id: 'navbar_browse_paths.amenities.cyclorama'
            }),
            url: '/es/plan/cyclorama',
            id: 'es-es_cyclorama'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Piano',
              id: 'navbar_browse_paths.amenities.piano'
            }),
            url: '/es/plan/piano',
            id: 'es-es_piano'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pool',
              id: 'navbar_browse_paths.amenities.pool'
            }),
            url: '/es/plan/pool',
            id: 'es-es_pool'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bathtub',
              id: 'navbar_browse_paths.amenities.bathtub'
            }),
            url: '/es/plan/bathtub',
            id: 'es-es_bathtub'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Patio',
              id: 'navbar_browse_paths.amenities.patio'
            }),
            url: '/es/plan/patio',
            id: 'es-es_patio'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Green Screen',
              id: 'navbar_browse_paths.amenities.green_screen'
            }),
            url: '/es/plan/green-screen',
            id: 'es-es_green_screen'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Deck',
              id: 'navbar_browse_paths.amenities.deck'
            }),
            url: '/es/plan/deck',
            id: 'es-es_deck'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fireplace',
              id: 'navbar_browse_paths.amenities.fireplace'
            }),
            url: '/es/plan/fireplace',
            id: 'es-es_fireplace'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Grill',
              id: 'navbar_browse_paths.amenities.grill'
            }),
            url: '/es/plan/grill',
            id: 'es-es_grill'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Fire Pit',
              id: 'navbar_browse_paths.amenities.fire_pit'
            }),
            url: '/es/plan/fire-pit',
            id: 'es-es_fire_pit'
          },
        ]
      },
      ideas: {
        display: intl.formatMessage({
          defaultMessage: 'Ideas',
          id: 'navbar_browse_paths.ideas'
        }),
        id: 'es-es_ideas',
        children: [
          {
            display: intl.formatMessage({
              defaultMessage: 'Photoshoot ideas',
              id: 'navbar_browse_paths.ideas.photoshoot_ideas'
            }),
            url: '/es/ideas/photo-shoot/all',
            id: 'es-es_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Baby shower ideas',
              id: 'navbar_browse_paths.ideas.baby_shower_ideas'
            }),
            url: '/es/ideas/baby-shower/all',
            id: 'es-es_baby_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Party ideas',
              id: 'navbar_browse_paths.ideas.party_ideas'
            }),
            url: '/es/ideas/party/all',
            id: 'es-es_party_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Bridal shower ideas',
              id: 'navbar_browse_paths.ideas.bridal_shower_ideas'
            }),
            url: '/es/ideas/bridal-shower/all',
            id: 'es-es_bridal_shower_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Birthday photoshoot ideas',
              id: 'navbar_browse_paths.ideas.birthday_photoshoot_ideas'
            }),
            url: '/es/ideas/birthday-photo-shoot/all',
            id: 'es-es_birthday_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Boudoir photoshoot ideas',
              id: 'navbar_browse_paths.ideas.boudoir_photoshoot_ideas'
            }),
            url: '/es/ideas/boudoir-photo-shoot/all',
            id: 'es-es_boudoir_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Couples photoshoot ideas',
              id: 'navbar_browse_paths.ideas.couples_photoshoot_ideas'
            }),
            url: '/es/ideas/couples-photo-shoot/all',
            id: 'es-es_couples_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Spring photoshoot ideas',
              id: 'navbar_browse_paths.ideas.spring_photoshoot_ideas'
            }),
            url: '/es/ideas/spring-photo-shoot/all',
            id: 'es-es_spring_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Outdoor photoshoot ideas',
              id: 'navbar_browse_paths.ideas.outdoor_photoshoot_ideas'
            }),
            url: '/es/ideas/outdoor-photo-shoot/all',
            id: 'es-es_outdoor_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Summer photoshoot ideas',
              id: 'navbar_browse_paths.ideas.summer_photoshoot_ideas'
            }),
            url: '/es/ideas/summer-photo-shoot/all',
            id: 'es-es_summer_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Black and white photoshoot ideas',
              id: 'navbar_browse_paths.ideas.black_and_white_photoshoot_ideas'
            }),
            url: '/es/ideas/black-and-white-photo-shoot/all',
            id: 'es-es_black_and_white_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'Pink photoshoot ideas',
              id: 'navbar_browse_paths.ideas.pink_photoshoot_ideas'
            }),
            url: '/es/ideas/pink-photo-shoot/all',
            id: 'es-es_pink_photoshoot_ideas'
          },
          {
            display: intl.formatMessage({
              defaultMessage: 'See all',
              id: 'navbar_browse_paths.ideas.see_all'
            }),
            url: '/es/ideas/all',
            id: 'es-es_see_all_ideas'
          }
        ]
      }
    }
  };

  return browsePaths[intl.locale.toLowerCase()];
};